var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { Label } from 'reactstrap';
import { Input } from '@app/Components/Input/Input';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { Modal } from '@app/Components/Modal/Modal';
import { Warnings } from '../../../AppConstants';
export var LinkModal = /** @class */ (function (_super) {
    __extends(LinkModal, _super);
    function LinkModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._link = '';
        _this._save = function () {
            var _a;
            var onSave = (_a = _this.props, _a.onSave), onToggle = _a.onToggle;
            onSave(_this._link);
            onToggle();
            _this._link = '';
        };
        return _this;
    }
    LinkModal.prototype.render = function () {
        var _a;
        var _this = this;
        var isOpen = (_a = this.props, _a.isOpen), onToggle = _a.onToggle;
        return (React.createElement("div", null,
            React.createElement(Modal, { isOpen: isOpen, toggle: onToggle, headerTitle: "Link", minWidth: "600px", footerbuttons: this._getFooterButtons() },
                React.createElement("div", null,
                    React.createElement("div", null,
                        React.createElement(Label, null,
                            "Link - ",
                            Warnings.DeliverableAsLinkWarning),
                        React.createElement(Input, { type: "text", value: this._link, onChange: function (e) { return (_this._link = e.target.value); } }))))));
    };
    LinkModal.prototype._getFooterButtons = function () {
        return [
            {
                color: 'success',
                onClick: this._save,
                disabled: !this._link,
                title: 'Save'
            },
            {
                onClick: this.props.onToggle,
                title: 'Close'
            }
        ];
    };
    __decorate([
        observable
    ], LinkModal.prototype, "_link", void 0);
    LinkModal = __decorate([
        observer
    ], LinkModal);
    return LinkModal;
}(React.PureComponent));
